/*
 * @Description: 全局方法
 * @Author: jml
 * @Github:
 * @LastEditors: Please set LastEditors
 * @Date: 2019-05-07 10:22:09
 * @LastEditTime: 2022-08-23 11:45:24
 */

import { Loading, Message } from 'element-ui';
import QRCode from 'qrcode';
import dateFormat from '@/tools/dateFormat';
import Config from '@/config';
import { download } from 'xrk-tools';
import { clientVersion } from '@/api/ajax';

function dealUrl(url, query) {
  if (!url) {
    throw new Error('对象必须包含url');
  }
  const _query = Object.keys(query).reduce((pre, cur) => {
    (query[cur] || query[cur] === 0 || query[cur] === '0') &&
      (pre[cur] = query[cur]);
    return pre;
  }, {});
  let strQuery = JSON.stringify(_query)
    .replace(/\{|\}|\"/g, '')
    .replace(/\,/g, '&')
    .replace(/\:/g, '=');
  strQuery = strQuery ? `?${strQuery}` : '';

  const _url = url + strQuery;
  window.open(_url, '_blank');
}

/**
 * 导出
 * @param {*} url
 * @param {*} query
 */
export const exportFile = (url, query = {}) => {
  dealUrl(url, query);
};

/**
 * 下载文件
 * @param {*} fileName
 * @param {*} content
 */
export const downloadFile = async (
  url,
  useResponseFileName,
  fileName,
  method
) => {
  return new Promise(async (resolve, reject) => {
    const loading = Loading.service({ fullscreen: true, text: '下载中...' });
    try {
      const res = await download.downloadFile(url, {
        fileName: fileName,
        useResponseFileName: useResponseFileName,
        tokenName: Config.token,
        requestTokenName: Config.token,
        method: method || 'get'
      });
      try {
        if (res.status == 0) {
          Message.error(res.message);
        }
      } catch (error) {}
      resolve(res);
    } catch (e) {
      Message.error('下载失败');
      reject();
    }
    loading.close();
  });
};

/**
 * 链接转为二维码
 * @param {*} url
 */
export const getQrcodeUrl = url => {
  const canvas = document.createElement('canvas');
  let backUrl = '';
  QRCode.toCanvas(canvas, url, error => {
    if (error) console.error(error);
    backUrl = canvas.toDataURL('image/png', 1);
  });
  return backUrl;
};

/**
 * 是否小于当前月份
 */
export const isAgo = month => {
  // console.log(month < dateFormat(new Date().getTime(), 'YYYY-MM'));
  return dateFormat(new Date().getTime(), 'YYYY-MM') > month;
};

export const updateVersion = async () => {
  const toVersion = v => {
    return (v + '').replace(/\./g, '');
  };
  const { VUE_APP_SCENE, VUE_APP_VERSION } = process.env;
  if (['online', 'pro-pre'].includes(VUE_APP_SCENE)) {
    const {
      pdata: { version, isOpen, isForceUpdate }
    } = await clientVersion.getVersion();
    let localV = toVersion(VUE_APP_VERSION);
    let onlineV = toVersion(version);
    const maxLen = Math.max(localV.length, onlineV.length);
    localV = +localV.padEnd(maxLen, '0');
    onlineV = +onlineV.padEnd(maxLen, '0');
    if (isOpen && isForceUpdate && onlineV > localV) {
      const path = window.location.href.split('/#/')[1];
      window.location.href = `${window.location.origin}?version=${version}/#/${path}`;
    }
  }
};
/**
 * @description: 打开新版本BI
 * @param {number} id biInfoId
 * @param {string} isEdit 0不可编辑，1可编辑
 * @param {string} platform 打开平台 默认当前平台
 * @param {number} selectType 201当期 202累计 203自定义。注意，新版老版该字段不一致。老版为：新UI接口调用之前的
 * @param {number} projectType 项目类型
 */
export const openV3BI = ({
  id,
  selectType = 201,
  isEdit = '1',
  platform = 'gongye',
  projectType = 0,
  projectId
}) => {
  window.open(
    `${Config.biUrl}?id=${id}&isEdit=${isEdit}&platform=${platform}&selectType=${selectType}&projectType=${projectType}&projectId=${projectId}`,
    '_blank'
  );
};
